import { ButtonLink, FontIcons } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { BrandfolderHexColors } from '@components/library/utils';

const ImageOverlayWrapper = styled.div`
  cursor: pointer;
  position: relative;
  width: 100%;
`;

const Overlay = styled.div`
  align-items: center;
  background-color: rgba(0, 1, 1, 0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  &:hover,
  &:focus,
  &:focus-within {
    opacity: 1;
  }
`;

const linkStyles = css`
  background-color: transparent;
  border: 1px solid ${BrandfolderHexColors.White};
  border-radius: 4px;
  color: ${BrandfolderHexColors.White};
  line-height: 20px;
  padding: 14px 20px;
  width: max-content;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: ${BrandfolderHexColors.White};
    color: ${BrandfolderHexColors.White};
  }
  &:active {
    background-color: rgba(255, 255, 255, 0.2);
  }
  &:disabled {
    border-color: rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.5);
  }
`;

const OverlayButtonLink = styled(ButtonLink)`
  ${linkStyles}
`;

const OverlayRouterLink = styled(Link)`
  ${linkStyles}
`;

interface LocationState {
  label: string;
  thumbnail: string;
  prevRoute: string;
}

interface ImageOverlayProps {
  buttonText: string;
  children: React.ReactNode;
  href?: string;
  icon?: FontIcons;
  linkTo?: string;
  locationState?: LocationState;
}

export const ImageOverlay: FunctionComponent<ImageOverlayProps> = ({
  children,
  buttonText,
  href = null,
  icon = null,
  linkTo = null,
  locationState = null,
}) => (
  <ImageOverlayWrapper>
    <Overlay>
      {linkTo ?
        <OverlayRouterLink
          state={locationState}
          to={linkTo}
        >
          {buttonText}
        </OverlayRouterLink> :
        <OverlayButtonLink href={href} startIcon={icon}>
          {buttonText}
        </OverlayButtonLink>
      }
    </Overlay>
    {children}
  </ImageOverlayWrapper>
);
